// Servicio de suscripciones
import { apiClient } from './api';
import { API_ENDPOINTS, API_BASE_URL } from '../config';

export const subscriptionService = {
  /**
   * Obtener o crear precio de suscripción
   * @returns {Promise<Object>} Price ID y detalles
   */
  async getPrice() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTION_PRICE || `${API_ENDPOINTS.USER}/subscription/price`);
      return response;
    } catch (error) {
      console.error('Error obteniendo precio:', error);
      throw error;
    }
  },

  /**
   * Crear suscripción mensual
   * @param {Object} subscriptionData - { payment_method_id, price_id (opcional) }
   * @returns {Promise<Object>} Datos de la suscripción
   */
  async createSubscription(subscriptionData) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SUBSCRIPTION_CREATE, subscriptionData);
      return response;
    } catch (error) {
      console.error('Error creando suscripción:', error);
      throw error;
    }
  },

  /**
   * Obtener información de la suscripción actual
   * @returns {Promise<Object>} Datos de la suscripción
   */
  async getSubscription() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTION || `${API_ENDPOINTS.USER}/subscription`);
      return response;
    } catch (error) {
      console.error('Error obteniendo suscripción:', error);
      throw error;
    }
  },

  /**
   * Obtener estado de la suscripción actual
   * @returns {Promise<Object>} Estado de la suscripción o null si no tiene suscripción
   */
  async getStatus() {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/api/subscription/status`);
      return response;
    } catch (error) {
      // Si el error es "Usuario no tiene suscripción", no es un error real, es un caso válido
      if (error.message && error.message.includes('Usuario no tiene suscripción')) {
        // Retornar un objeto que indica que no hay suscripción
        return {
          success: false,
          data: null,
          error: 'Usuario no tiene suscripción',
          has_subscription: false,
        };
      }
      // Para otros errores, loguear y lanzar
      console.error('Error obteniendo estado de suscripción:', error);
      throw error;
    }
  },

  /**
   * Actualizar suscripción desde Stripe (después de confirmar pago)
   * @returns {Promise<Object>} Datos actualizados de la suscripción
   */
  async refreshSubscription() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SUBSCRIPTION_REFRESH || `${API_BASE_URL}/api/subscription/refresh`);
      return response;
    } catch (error) {
      console.error('Error actualizando suscripción:', error);
      throw error;
    }
  },

  /**
   * Confirmar PaymentIntent de una suscripción incomplete
   * @returns {Promise<Object>} Datos de la suscripción actualizada
   */
  async confirmPaymentIntent() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SUBSCRIPTION_CONFIRM_PAYMENT || `${API_BASE_URL}/api/subscription/confirm-payment`);
      return response;
    } catch (error) {
      console.error('Error confirmando PaymentIntent:', error);
      throw error;
    }
  },

  /**
   * Cancelar suscripción
   * @returns {Promise<Object>} Confirmación de cancelación
   * Retorna: { success, message, data: { subscription_id, status, cancel_at_period_end, current_period_end } }
   */
  async cancelSubscription() {
    try {
      // apiClient.post ya retorna el objeto data parseado del backend
      const result = await apiClient.post(API_ENDPOINTS.SUBSCRIPTION_CANCEL || `${API_ENDPOINTS.USER}/subscription/cancel`);
      return result; // { success, message, data: { ... } }
    } catch (error) {
      console.error('Error cancelando suscripción:', error);
      throw error;
    }
  },
};
